function _s(o, i, p, l) {
  void 0 === i && (i = 400),
    void 0 === l && (l = !1),
    (o.style.overflow = "hidden"),
    l && (o.style.display = "block");
  var n,
    t = window.getComputedStyle(o),
    s = parseFloat(t.getPropertyValue("height")),
    a = parseFloat(t.getPropertyValue("padding-top")),
    r = parseFloat(t.getPropertyValue("padding-bottom")),
    y = parseFloat(t.getPropertyValue("margin-top")),
    d = parseFloat(t.getPropertyValue("margin-bottom")),
    g = s / i,
    m = a / i,
    h = r / i,
    u = y / i,
    x = d / i;
  window.requestAnimationFrame(function t(e) {
    void 0 === n && (n = e);
    e -= n;
    l
      ? ((o.style.height = g * e + "px"),
        (o.style.paddingTop = m * e + "px"),
        (o.style.paddingBottom = h * e + "px"),
        (o.style.marginTop = u * e + "px"),
        (o.style.marginBottom = x * e + "px"))
      : ((o.style.height = s - g * e + "px"),
        (o.style.paddingTop = a - m * e + "px"),
        (o.style.paddingBottom = r - h * e + "px"),
        (o.style.marginTop = y - u * e + "px"),
        (o.style.marginBottom = d - x * e + "px")),
      i <= e
        ? ((o.style.height = ""),
          (o.style.paddingTop = ""),
          (o.style.paddingBottom = ""),
          (o.style.marginTop = ""),
          (o.style.marginBottom = ""),
          (o.style.overflow = ""),
          l || (o.style.display = "none"),
          "function" == typeof p && p())
        : window.requestAnimationFrame(t);
  });
}
(HTMLElement.prototype.slideToggle = function (t, e) {
  0 === this.clientHeight ? _s(this, t, e, !0) : _s(this, t, e);
}),
  (HTMLElement.prototype.slideUp = function (t, e) {
    _s(this, t, e);
  }),
  (HTMLElement.prototype.slideDown = function (t, e) {
    _s(this, t, e, !0);
  });

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function findGetParameter(parameterName) {
  var result = null,
    tmp = [];
  location.search
    .substr(1)
    .split("&")
    .forEach(function (item) {
      tmp = item.split("=");
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    });
  return result;
}

window.addEventListener("load", function (event) {
  var color = findGetParameter("filter.v.option.couleur");
  if (color) {
    document
      .querySelectorAll('[data-variant-color="' + color + '"]')
      .forEach((item) => {
        item.click();
      });
  }
});

if (findGetParameter("open") == "cart") {
  openCartSlideHQ();
}

function openCartSlideHQ() {
  if (document.querySelector(".slidecarthq .items")) {
    document.querySelector("#cart-menu-link").click();

    // remove param from url
    var url = window.location.href;
    var newUrl = url.split("?")[0];
    window.history.pushState({ path: newUrl }, "", newUrl);
  } else {
    setTimeout(openCartSlideHQ, 200);
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.updateButton();
    this.updateDatas();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateDatas() {
    if (this.querySelector(".data-variant-id")) {
      console.log(
        this.querySelectorAll(".custom-select_label .main-span").forEach(
          (item) => {
            item.classList.add("hidden");

            if (
              this.currentVariant.id ==
              Number(item.getAttribute("data-label-id"))
            ) {
              item.classList.remove("hidden");
            }
          }
        )
      );

      this.querySelector(".data-variant-id").value = this.currentVariant.id;

      const price = this.currentVariant.price / 100;

      if (this.parentNode.querySelector(".show_price")) {
        console.log(this.parentNode.dataset.multiplier);

        let multiplier = Number(
          this.parentNode.querySelector(".show_price").dataset.multiplier
        );

        console.log(multiplier);

        let price_promoted = price * multiplier;

        console.log(price_promoted);

        this.parentNode.querySelector(
          ".product-card__button-price--new"
        ).textContent = price_promoted.toFixed(2).toString().includes(".00")
          ? price_promoted.toFixed(0) + "€"
          : price_promoted.toFixed(2) + "€";
      }

      if (
        this.parentNode.querySelector(
          ".product-card__button .product-card__button-price"
        )
      ) {
        // Si nous avons un compare_at_price, on l'affiche comme prix barré
        if (this.currentVariant.compare_at_price) {
          const comparePrice = this.currentVariant.compare_at_price / 100;
          this.parentNode.querySelector(
            ".product-card__button .product-card__button-price"
          ).textContent = comparePrice.toFixed(2).toString().includes(".00")
            ? comparePrice.toFixed(0) + "€"
            : comparePrice.toFixed(2) + "€";
        } else {
          // Sinon on affiche le prix normal
          this.parentNode.querySelector(
            ".product-card__button .product-card__button-price"
          ).textContent = price.toFixed(2).toString().includes(".00")
            ? price.toFixed(0) + "€"
            : price.toFixed(2) + "€";
        }
      } else {
        if (this.currentVariant.available == false) {
          document.querySelector(
            ".product-template__bottom-bar .product-template__button-text"
          )
            ? document
                .querySelector(
                  ".product-template__bottom-bar .product-template__button-text"
                )
                .classList.remove("hidden")
            : null;
          document.querySelector(
            ".product-template__bottom-bar .product-template__button-submit"
          )
            ? document
                .querySelector(
                  ".product-template__bottom-bar .product-template__button-submit"
                )
                .classList.add("hidden")
            : null;
        } else {
          document.querySelector(
            ".product-template__bottom-bar .product-template__button-text"
          )
            ? document
                .querySelector(
                  ".product-template__bottom-bar  .product-template__button-text"
                )
                .classList.add("hidden")
            : null;
          document.querySelector(
            ".product-template__bottom-bar .product-template__button-submit"
          )
            ? document
                .querySelector(
                  ".product-template__bottom-bar .product-template__button-submit"
                )
                .classList.remove("hidden")
            : null;
        }

        this.querySelector(".data-variant-product-id").value =
          this.currentVariant.id;

        const price = this.currentVariant.price / 100;

        let multiplier = Number(
          this.parentNode.parentNode.querySelector(".show_price").dataset
            .multiplier
        );

        let price_promoted = price * multiplier;

        if (this.currentVariant.compare_at_price && this.currentVariant.compare_at_price > this.currentVariant.price) {
          const compareAtPrice = this.currentVariant.compare_at_price / 100;
          this.parentNode.parentNode.querySelector(
            ".product-template__bottom-bar  .product-card__button-price__content"
          ).textContent = compareAtPrice.toFixed(2) + "€";
          this.parentNode.parentNode.querySelector(
            ".product-template__bottom-bar  .product-card__button-price--new"
          ).textContent = price.toFixed(2) + "€";
        } else {
          this.parentNode.parentNode.querySelector(
            ".product-template__bottom-bar  .product-card__button-price__content"
          ).textContent = price.toFixed(2) + "€";
          this.parentNode.parentNode.querySelector(
            ".product-template__bottom-bar  .product-card__button-price--new"
          ).textContent = price_promoted.toFixed(2) + "€";
        }
      }
    } else {
      if (this.currentVariant.available == false) {
        document.querySelector(
          ".product-template__bottom-bar .product-template__button-text"
        )
          ? document
              .querySelector(
                ".product-template__bottom-bar .product-template__button-text"
              )
              .classList.remove("hidden")
          : null;
        document.querySelector(
          ".product-template__bottom-bar .product-template__button-submit"
        )
          ? document
              .querySelector(
                ".product-template__bottom-bar .product-template__button-submit"
              )
              .classList.add("hidden")
          : null;
      } else {
        document.querySelector(
          ".product-template__bottom-bar .product-template__button-text"
        )
          ? document
              .querySelector(
                ".product-template__bottom-bar .product-template__button-text"
              )
              .classList.add("hidden")
          : null;
        document.querySelector(
          ".product-template__bottom-bar .product-template__button-submit"
        )
          ? document
              .querySelector(
                ".product-template__bottom-bar .product-template__button-submit"
              )
              .classList.remove("hidden")
          : null;
      }

      this.querySelector(".data-variant-product-id").value =
        this.currentVariant.id;

      const price = this.currentVariant.price / 100;

      if (this.parentNode.querySelector(".show_price")) {
        let multiplier = Number(
          this.parentNode.querySelector(".show_price").dataset.multiplier
        );

        let price_promoted = price * multiplier;
      }
      if (this.currentVariant.compare_at_price && this.currentVariant.compare_at_price > this.currentVariant.price) {
        const compareAtPrice = this.currentVariant.compare_at_price / 100;
        this.parentNode.querySelector(
          ".product-template__form-container .product-card__button-price__content"
        ).textContent = compareAtPrice.toFixed(2) + "€";
        this.parentNode.querySelector(
          ".product-template__form-container .product-card__button-price--new"
        ).textContent = price.toFixed(2) + "€";
      } else {
        this.parentNode.querySelector(
          ".product-template__form-container .product-card__button-price__content"
        ).textContent = price.toFixed(2) + "€";
        if (this.parentNode.querySelector(".show_price")) {
          this.parentNode.querySelector(
            ".product-template__form-container .product-card__button-price--new"
          ).textContent = price_promoted.toFixed(2) + "€";
        }
      }
    }
  }

  updateButton() {
    if (this.currentVariant.available == false) {
      document.querySelector(".product-template__button-text")
        ? document
            .querySelector(".product-template__button-text")
            .classList.remove("hidden")
        : null;
      document.querySelector(".product-template__button-submit")
        ? document
            .querySelector(".product-template__button-submit")
            .classList.add("hidden")
        : null;
    } else {
      document.querySelector(".product-template__button-text")
        ? document
            .querySelector(".product-template__button-text")
            .classList.add("hidden")
        : null;
      document.querySelector(".product-template__button-submit")
        ? document
            .querySelector(".product-template__button-submit")
            .classList.remove("hidden")
        : null;
    }

    if (this.parentNode.querySelector("variant-radios")) {
      const price = this.currentVariant.price / 100;
      const compareAtPrice = this.currentVariant.compare_at_price
        ? this.currentVariant.compare_at_price / 100
        : null;

      if (compareAtPrice && compareAtPrice > price) {
        // Variant has compare_at_price - update button to show compare_at_price
        this.parentNode.querySelector(
          ".product-template__form-container .product-card__button-price__content"
        ).textContent = compareAtPrice.toFixed(2) + "€";
        this.parentNode.querySelector(
          ".product-template__form-container .product-card__button-price--new"
        ).textContent = price.toFixed(2) + "€";
      } else if (this.parentNode.querySelector(".show_price")) {
        // Variant has collection discount - update button with multiplier
        let multiplier = Number(
          this.parentNode.querySelector(".show_price").dataset.multiplier
        );

        let price_promoted = price * multiplier;

        console.log(price_promoted);

        this.parentNode.querySelector(
          ".product-template__form-container .product-card__button-price__content"
        ).textContent = price.toFixed(2) + "€";
        this.parentNode.querySelector(
          ".product-template__form-container .product-card__button-price--new"
        ).textContent = price_promoted.toFixed(2) + "€";
      }
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    console.log(this.parentNode);
    console.log(this.parentNode.parentNode);
    if (
      this.parentNode.classList.contains("main-product-form") ||
      this.parentNode.parentNode.classList.contains(
        "product-template__bottom-bar"
      )
    ) {
      if (!this.currentVariant || this.dataset.updateUrl === "false") return;
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}`
      );
    } else {
      if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    }
  }
  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    if (!this.currentVariant) return;
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === ""
          );

        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;

    let addButton = null;
    if (productForm.querySelector('[name="add"]')) {
      addButton = productForm.querySelector('[name="add"]');
    }
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = null;

    console.log(button);
    if (button) {
      if (button.querySelector('[name="add"]')) {
        addButton = button.querySelector('[name="add"]');
      }
    }
    const addButtonText = null;
    if (button) {
      addButtonText = button.querySelector('[name="add"] > span');
    }
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

window.theme = window.theme || {};

theme.MobileNav = (function () {
  var classes = {
    mobileNavOpenIcon: "mobile-nav--open",
    mobileNavCloseIcon: "mobile-nav--close",
    navLinkWrapper: "mobile-nav__item",
    navLink: "mobile-nav__link",
    subNavLink: "mobile-nav__sublist-link",
    return: "mobile-nav__return-btn",
    subNavActive: "is-active",
    subNavClosing: "is-closing",
    navOpen: "js-menu--is-open",
    subNavShowing: "sub-nav--is-open",
    thirdNavShowing: "third-nav--is-open",
    subNavToggleBtn: "js-toggle-submenu",
  };

  var cache = {};
  var isTransitioning;
  var activeSubNav;
  var activeTrigger;
  var menuLevel = 1;
  var mediumUpQuery = "(min-width: 100000px)";
  var mql = window.matchMedia(mediumUpQuery);

  init();

  function init() {
    cacheSelectors();
    if (cache.mobileNavToggle) {
      cache.mobileNavToggle.addEventListener("click", toggleMobileNav);
    }
    if (cache.mobileNavToggleClose) {
      cache.mobileNavToggleClose.addEventListener("click", toggleMobileNav);
    }

    cache.subNavToggleBtns.forEach(function (element) {
      element.addEventListener("click", toggleSubNav);
    });

    document.addEventListener(
      "click",
      function (e) {
        if (
          !e.target.closest(".js-mobile-nav-toggle") &&
          !e.target.closest(".mobile-nav-wrapper")
        ) {
          closeMobileNav();
        }
      }.bind(this)
    );

    mql.addListener(initBreakpoints);
  }

  function initBreakpoints() {
    if (
      mql.matches &&
      cache.mobileNavContainer.classList.contains(classes.navOpen)
    ) {
      closeMobileNav();
    }
  }

  function toggleMobileNav() {
    var mobileNavIsOpen = document.querySelector(
      ".mobile-nav-wrapper.js-menu--is-open"
    )
      ? true
      : false;

    if (mobileNavIsOpen) {
      closeMobileNav();
    } else {
      openMobileNav();
    }
  }

  function cacheSelectors() {
    cache = {
      pageContainer: document.querySelector("#MainContent"),
      siteHeader: document.querySelector(".Header"),
      mobileNavToggle: document.querySelector(".js-mobile-nav-toggle"),
      mobileNavToggleClose: document.querySelector(
        ".js-mobile-nav-toggle-close"
      ),
      mobileNavContainer: document.querySelector(".mobile-nav-wrapper"),
      mobileNav: document.querySelector("#MobileNav"),
      sectionHeader: document.querySelector("#shopify-section-header"),
      subNavToggleBtns: document.querySelectorAll(
        "." + classes.subNavToggleBtn
      ),
    };
  }

  function openMobileNav() {
    var translateHeaderHeight = cache.siteHeader.offsetHeight;

    theme.Helpers.prepareTransition(cache.mobileNavContainer);
    cache.mobileNavContainer.classList.add(classes.navOpen);

    cache.mobileNavContainer.style.transform =
      "translateY(calc(0% - var(--banner-height)))";

    document
      .querySelector(".header-container")
      .classList.add("header-container--open");

    document.querySelector("body").classList.add("overflow-body");

    cache.mobileNavToggle.classList.add(classes.mobileNavCloseIcon);
    cache.mobileNavToggle.classList.remove(classes.mobileNavOpenIcon);
    cache.mobileNavToggle.setAttribute("aria-expanded", true);

    window.addEventListener("keyup", keyUpHandler);

    document.getElementById("cart-menu-link").classList.add("hidden");
    // document.getElementById("site-header-logo").classList.add("hidden");
    document.getElementById("section-w-header").classList.add("no-limit");
  }

  function keyUpHandler(event) {
    if (event.which === 27) {
      closeMobileNav();
    }
  }

  function closeMobileNav() {
    theme.Helpers.prepareTransition(cache.mobileNavContainer);
    cache.mobileNavContainer.classList.remove(classes.navOpen);
    cache.mobileNavContainer.style.transform =
      "translateY(calc(-100% - calc(var(--header-height) + var(--banner-height))))";
    cache.pageContainer.setAttribute("style", "");

    document.querySelector("body").classList.remove("overflow-body");
    document
      .querySelector(".header-container")
      .classList.remove("header-container--open");

    cache.mobileNavContainer.addEventListener(
      "transitionend",
      mobileNavRemoveTrapFocus,
      { once: true }
    );

    cache.mobileNavToggle.classList.add(classes.mobileNavOpenIcon);
    cache.mobileNavToggle.classList.remove(classes.mobileNavCloseIcon);
    cache.mobileNavToggle.setAttribute("aria-expanded", false);
    cache.mobileNavToggle.focus();

    window.removeEventListener("keyup", keyUpHandler);

    document.getElementById("cart-menu-link").classList.remove("hidden");
    // document.getElementById("site-header-logo").classList.remove("hidden");
    document.getElementById("section-w-header").classList.remove("no-limit");
  }

  function mobileNavRemoveTrapFocus() {}

  function toggleSubNav(event) {
    console.log("toggleSubNav");
    if (isTransitioning) return;

    var toggleBtn = event.currentTarget;
    var isReturn = toggleBtn.classList.contains(classes.return);
    console.log("toggleBtn : ", toggleBtn);
    console.log("isReturn : ", isReturn);

    // isTransitioning = true;

    if (isReturn) {
      var subNavToggleBtn = document.querySelectorAll(
        "." + classes.subNavToggleBtn + "[data-level='" + (menuLevel - 1) + "']"
      );

      subNavToggleBtn.forEach(function (element) {
        element.classList.remove(classes.subNavActive);
      });

      if (activeTrigger) {
        activeTrigger.classList.remove(classes.subNavActive);
      }
      toggleBtn.classList.remove(classes.subNavActive);
      toggleBtn.classList.remove(classes.return);
      console.log("remove classes");
    } else {
      console.log("add classes");
      toggleBtn.classList.add(classes.subNavActive);
      toggleBtn.classList.add(classes.return);
    }

    activeTrigger = toggleBtn;

    goToSubnav(toggleBtn.getAttribute("data-target"));
  }

  function goToSubnav(target) {
    const targetName =
      '.mobile-nav__dropdown[data-parent="' + target.replace(/\s+/g, "") + '"]';
    var targetMenu = target
      ? document.querySelector(targetName)
      : cache.mobileNav;

    menuLevel = targetMenu.dataset.level ? Number(targetMenu.dataset.level) : 1;

    if (activeSubNav) {
      theme.Helpers.prepareTransition(activeSubNav);
      activeSubNav.classList.add(classes.subNavClosing);
    }

    activeSubNav = targetMenu;

    var translateMenuHeight = targetMenu.offsetHeight;

    var openNavClass =
      menuLevel > 2 ? classes.thirdNavShowing : classes.subNavShowing;

    // cache.mobileNavContainer.style.height = translateMenuHeight + "px";
    cache.mobileNavContainer.classList.remove(classes.thirdNavShowing);
    cache.mobileNavContainer.classList.add(openNavClass);

    if (!target) {
      cache.mobileNavContainer.classList.remove(
        classes.thirdNavShowing,
        classes.subNavShowing
      );
    }

    /* if going back to first subnav, focus is on whole header */
    var container = menuLevel === 1 ? cache.sectionHeader : targetMenu;

    cache.mobileNavContainer.addEventListener(
      "transitionend",
      trapMobileNavFocus,
      { once: true }
    );

    function trapMobileNavFocus() {
      cache.mobileNavContainer.removeEventListener(
        "transitionend",
        trapMobileNavFocus
      );

      isTransitioning = false;
    }

    // Match height of subnav
    // cache.pageContainer.style.transform =
    // "translateY(" + translateMenuHeight + "px)";

    activeSubNav.classList.remove(classes.subNavClosing);
  }

  function unload() {
    // mql.removeListener(initBreakpoints);
  }

  return {
    init: init,
    unload: unload,
    closeMobileNav: closeMobileNav,
  };
})();

theme.Helpers = (function () {
  var touchDevice = false;

  var classes = {
    preventScrolling: "prevent-scrolling",
  };

  var scrollPosition = window.pageYOffset;

  function setTouch() {
    touchDevice = true;
  }

  function isTouch() {
    return touchDevice;
  }

  function enableScrollLock() {
    scrollPosition = window.pageYOffset;
    document.body.style.top = "-" + scrollPosition + "px";
    document.body.classList.add(classes.preventScrolling);
  }

  function disableScrollLock() {
    document.body.classList.remove(classes.preventScrolling);
    document.body.style.removeProperty("top");
    window.scrollTo(0, scrollPosition);
  }

  function debounce(func, wait, immediate) {
    var timeout;

    return function () {
      var context = this,
        args = arguments;

      var later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };

      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  function getScript(source, beforeEl) {
    return new Promise(function (resolve, reject) {
      var script = document.createElement("script");
      var prior = beforeEl || document.getElementsByTagName("script")[0];

      script.async = true;
      script.defer = true;

      // eslint-disable-next-line shopify/prefer-early-return
      function onloadHander(_, isAbort) {
        if (
          isAbort ||
          !script.readyState ||
          /loaded|complete/.test(script.readyState)
        ) {
          script.onload = null;
          script.onreadystatechange = null;
          script = undefined;

          if (isAbort) {
            reject();
          } else {
            resolve();
          }
        }
      }

      script.onload = onloadHander;
      script.onreadystatechange = onloadHander;

      script.src = source;
      prior.parentNode.insertBefore(script, prior);
    });
  }

  /* Based on the prepareTransition by Jonathan Snook */
  /* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
  function prepareTransition(element) {
    element.addEventListener(
      "transitionend",
      function (event) {
        event.currentTarget.classList.remove("is-transitioning");
      },
      { once: true }
    );

    var properties = [
      "transition-duration",
      "-moz-transition-duration",
      "-webkit-transition-duration",
      "-o-transition-duration",
    ];

    var duration = 0;

    properties.forEach(function (property) {
      var computedValue = getComputedStyle(element)[property];

      if (computedValue) {
        computedValue.replace(/\D/g, "");
        duration || (duration = parseFloat(computedValue));
      }
    });

    if (duration !== 0) {
      element.classList.add("is-transitioning");
      element.offsetWidth;
    }
  }

  /*!
   * Serialize all form data into a SearchParams string
   * (c) 2020 Chris Ferdinandi, MIT License, https://gomakethings.com
   * @param  {Node}   form The form to serialize
   * @return {String}      The serialized form data
   */
  function serialize(form) {
    var arr = [];
    Array.prototype.slice.call(form.elements).forEach(function (field) {
      if (
        !field.name ||
        field.disabled ||
        ["file", "reset", "submit", "button"].indexOf(field.type) > -1
      )
        return;
      if (field.type === "select-multiple") {
        Array.prototype.slice.call(field.options).forEach(function (option) {
          if (!option.selected) return;
          arr.push(
            encodeURIComponent(field.name) +
              "=" +
              encodeURIComponent(option.value)
          );
        });
        return;
      }
      if (["checkbox", "radio"].indexOf(field.type) > -1 && !field.checked)
        return;
      arr.push(
        encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value)
      );
    });
    return arr.join("&");
  }
  function cookiesEnabled() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = "testcookie";
      cookieEnabled = document.cookie.indexOf("testcookie") !== -1;
    }

    return cookieEnabled;
  }

  function promiseStylesheet(stylesheet) {
    var stylesheetUrl = stylesheet || theme.stylesheet;

    if (typeof this.stylesheetPromise === "undefined") {
      this.stylesheetPromise = new Promise(function (resolve) {
        var link = document.querySelector('link[href="' + stylesheetUrl + '"]');

        if (link.loaded) resolve();

        link.addEventListener("load", function () {
          setTimeout(resolve, 0);
        });
      });
    }

    return this.stylesheetPromise;
  }

  return {
    setTouch: setTouch,
    isTouch: isTouch,
    enableScrollLock: enableScrollLock,
    disableScrollLock: disableScrollLock,
    debounce: debounce,
    getScript: getScript,
    prepareTransition: prepareTransition,
    serialize: serialize,
    cookiesEnabled: cookiesEnabled,
    promiseStylesheet: promiseStylesheet,
  };
})();

class PresentationSlider extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll(".presentation-slider__slide").forEach((slide) => {
      const buttons = slide.querySelectorAll(".custom-button-small");
      buttons.forEach((button) => {
        let buttonId = button.getAttribute("data-button-id");
        if (buttonId == 0) {
          button.classList.add("actif");
        }
        button.addEventListener("click", this.moveSlide.bind(this));
      });
    });

    this.swiper = new Swiper(this.querySelector(".presentation-swipper"), {
      // Optional parameters
      direction: "horizontal",
      allowTouchMove: false,
      loop: false,
      effect: "fade",
      fadeEffect: { crossFade: true },
      speed: 230,
      pagination: {
        el: this.querySelector(".swiper-pagination"),
      },
    });
  }
  moveSlide = (e) => {
    let button = e.currentTarget;
    let buttonId = button.getAttribute("data-button-id");
    this.querySelectorAll(".custom-button-small").forEach((el) => {
      el.classList.remove("actif");
    });
    let buttons = this.querySelectorAll(
      `[data-button-id='${buttonId}']`
    ).forEach((button) => {
      button.classList.add("actif");
    });
    this.swiper.slideTo(buttonId, 1000, true);
  };
}

customElements.define("presentation-slider", PresentationSlider);

class FAQ extends HTMLElement {
  constructor() {
    super();
    this.initEventListener();
  }
  initEventListener() {
    this.querySelectorAll(".faq-item-title").forEach((button) => {
      button.addEventListener("click", this.toggleFaqItem.bind(this));
    });
  }

  toggleFaqItem(e) {
    e.currentTarget
      .querySelector(".faq-close")
      .classList.toggle("faq-display-none");
    const item = e.currentTarget.parentNode.querySelector(".faq-item-text");
    item.slideToggle("250");
  }
}

customElements.define("faq-container", FAQ);

class RecommandationSlider extends HTMLElement {
  constructor() {
    super();

    const swiper = new Swiper(this.querySelector(".recommandation-swiper"), {
      // Optional parameters
      direction: "horizontal",
      loop: false,
      slidesPerView: "auto",
    });
  }
}

customElements.define("recommandation-slider", RecommandationSlider);

class CollectionProductListSwiper extends HTMLElement {
  constructor() {
    super();

    this.updateHeightContent();
    window.addEventListener("resize", this.updateHeightContent.bind(this));
    window.addEventListener("resize", this.updateSwiper);
    const buttons = this.querySelectorAll(
      ".collection-product-list__braedcrumbs-button"
    );

    buttons.forEach((button) => {
      button.addEventListener("click", this.changeCollection.bind(this));
    });

    this.swiper = new Swiper(
      this.querySelector(".collection-product-list-swiper"),
      {
        // Optional parameters
        direction: "horizontal",
        loop: false,
        slidesPerView: "auto",
        freeMode: true,
        cssMode: true,
        // If we need pagination
        pagination: {
          el: this.querySelector(".swiper-pagination"),
        },

        // Navigation arrows
        navigation: {
          nextEl: this.querySelector(".swiper-button-next"),
          prevEl: this.querySelector(".swiper-button-prev"),
        },

        // And if we need scrollbar
        scrollbar: {
          el: this.querySelector(".swiper-scrollbar"),
          draggable: true,
        },
        mousewheel: {
          invert: false,
          forceToAxis: true,
        },
        breakpoints: {
          990: {
            cssMode: false,
          },
        },
      }
    );
    //this.updateSwiper()
    this.querySelectorAll(".collection-product-list__text p").forEach((p) => {
      this.updateDescription(p);
    });
  }

  changeCollection = (e) => {
    let button = e.currentTarget;
    let buttons = this.querySelectorAll(
      ".collection-product-list__braedcrumbs-button"
    );
    buttons.forEach((allbuttons) => {
      allbuttons.classList.remove("actif");
    });
    button.classList.add("actif");
    let buttonCollectionHandle = button.getAttribute("show-collection-handle");

    // changement de classe des slides
    let slideCollection = this.querySelectorAll(".swiper-slide");
    slideCollection.forEach((slide) => {
      let slideCollectionHandle = slide.getAttribute("data-collection-handle");
      if (slideCollectionHandle == buttonCollectionHandle) {
        slide.classList.remove("hidden");
      } else {
        slide.classList.add("hidden");
      }
    });

    let buttonCollection = this.querySelectorAll(
      ".collection-product-list__button"
    );
    buttonCollection.forEach((button) => {
      let aCollectionHandle = button.getAttribute("data-collection-handle");
      if (aCollectionHandle == buttonCollectionHandle) {
        button.classList.remove("hidden");
      } else {
        button.classList.add("hidden");
      }
    });
    this.swiper.update();
    this.swiper.slideTo(0);
  };

  updateHeightContent() {
    const maxHeight = [];

    this.querySelectorAll(".product-image__text ").forEach((item) => {
      maxHeight.push(item.offsetHeight);
    });

    this.querySelectorAll(".product-image__text").forEach((item) => {
      item.style.height = `${Math.max(...maxHeight)}px`;
    });
  }

  updateSwiper = (e) => {
    if (window.innerWidth < 750) {
      this.querySelectorAll(".swiper-slide").forEach((el) => {
        el.classList.remove("hidden");
      });
      this.swiper.update();
      this.swiper.slideTo(0);
    } else {
      this.removeExpandDescription();
      this.querySelectorAll(
        ".collection-product-list__braedcrumbs-button"
      ).forEach((el) => {
        let dataId = el.getAttribute("button-id");
        if (dataId == "1") {
          el.click();
          this.swiper.update();
          this.swiper.slideTo(0);
        }
      });
    }
  };
  updateDescription = (description) => {
    const max_height = 60;
    const descriptionHeight = description.offsetHeight;

    if (descriptionHeight > max_height) {
      this.getMaxWords(description, max_height);
    }
  };

  getMaxWords = (description, max_height) => {
    let descriptionText = "";

    if (description.querySelector("[data-expand]")) {
      description.querySelector("[data-expand]").remove();
    }

    if (description.querySelectorAll("button").length > 0) {
      description.querySelectorAll(".reduce").forEach((button) => {
        button.remove();
      });
    }

    const descriptionTextArray = description.innerHTML.split(" ");

    for (let i = 0; i < descriptionTextArray.length; i++) {
      description.innerHTML.replace(" [...]", "");
      descriptionText += descriptionTextArray[i] + " ";
      description.innerHTML = descriptionText + " [...]";
      if (description.offsetHeight > max_height) {
        description.innerHTML =
          descriptionTextArray.slice(0, i).join(" ") +
          `<span data-expand="${descriptionTextArray
            .slice(i, descriptionTextArray.length)
            .join(" ")}"> [...]</span>`;
        description.innerHTML = description.innerHTML;
        console.log(description, description.innerHTML);
        description.innerHTML =
          description.innerHTML + `<button class="see-more">Voir plus</button>`;
        description
          .querySelector(".see-more")
          .addEventListener("click", (e) => {
            this.expandDescription(description, e);
          });
        break;
      }
    }
  };

  expandDescription = (description, e) => {
    if (description.querySelector("[data-expand]")) {
      const descriptionText = description
        .querySelector("[data-expand]")
        .getAttribute("data-expand");

      description.innerHTML += " " + descriptionText;
      description.querySelector("[data-expand]").remove();
      description.querySelector(".see-more").remove();
      description.innerHTML += `<button class="reduce">Réduire</button>`;
      description.querySelector(".reduce").addEventListener("click", () => {
        this.updateDescription(description);
      });
    }
  };

  removeExpandDescription() {
    this.querySelectorAll(".collection-product-list__text p").forEach((p) => {
      this.expandDescription(p);
      if (p.querySelector("[data-expand]")) {
        p.querySelector("[data-expand]").remove();
      }

      if (p.querySelectorAll("button").length > 0) {
        p.querySelectorAll("button").forEach((button) => {
          button.remove();
        });
      }
    });
  }
}
customElements.define("collection-product-list", CollectionProductListSwiper);

class CollectionListSlider extends HTMLElement {
  constructor() {
    super();
    let duration = this.querySelector("[data-swiper-duration]").getAttribute(
      "data-swiper-duration"
    );
    const swiper = new Swiper(this.querySelector(".collection-swiper"), {
      // Optional parameters
      direction: "horizontal",
      loop: false,
      spaceBetween: 25,
      autoplay: {
        delay: duration,
        disableOnInteraction: false,
      },
      slidesPerView: "auto",
      // If we need pagination
      pagination: {
        el: this.querySelector(".swiper-pagination"),
      },

      // Navigation arrows
      navigation: {
        nextEl: this.querySelector(".collection-swiper-button-next"),
        prevEl: this.querySelector(".collection-swiper-button-prev"),
      },
      mousewheel: {
        invert: false,
        forceToAxis: true,
      },

      // And if we need scrollbar
      scrollbar: {
        el: this.querySelector(".swiper-scrollbar"),
      },

      breakpoints: {
        990: {
          slidesPerView: 3,
        },
      },
    });
  }
}

customElements.define("collection-list", CollectionListSlider);

document.querySelectorAll("[data-open-service]").forEach((button) => {
  button.addEventListener("click", (e) => {
    console.log("click");
    document
      .querySelector(".section-service-client")
      .classList.remove("hidden");
    document.body.classList.add("w-overflow-body");
    console.log("click");
  });
});

document
  .querySelector(".modal-container svg")
  .addEventListener("click", (e) => {
    document.querySelector(".section-service-client").classList.add("hidden");
    document.body.classList.remove("w-overflow-body");
  });

document.addEventListener(
  "click",
  function (e) {
    if (
      !e.target.closest("[data-open-service]") &&
      !e.target.closest(".section-service-client")
    ) {
      document.querySelector(".section-service-client").classList.add("hidden");
      document.body.classList.remove("w-overflow-body");
    }
  }.bind(this)
);

document.documentElement.style.setProperty(
  "--header-height",
  `${document.querySelector(".header-container ").offsetHeight}px`
);

window.addEventListener("scroll", setHeaderNotTransparent);

function setHeaderNotTransparent() {
  if (document.querySelector(".template-index")) {
    if (window.scrollY > 0) {
      document
        .querySelector(".header-container")
        .classList.remove("header-container-transparent");
    } else {
      document
        .querySelector(".header-container")
        .classList.add("header-container-transparent");
    }
  }
}

class DoubleBlock extends HTMLElement {
  constructor() {
    super();

    this.fetchData();
  }

  fetchData() {
    fetch(`/`)
      .then((response) => response.text())
      .then((responseText) => {
        this.innerHTML = responseText
          .split("<double-block-origin>")[1]
          .split("</double-block-origin>")[0];
        this.querySelector(".section-discover").style.display = "block";
      });
  }
}

customElements.define("double-block", DoubleBlock);

(function () {
  const buttons = document.querySelectorAll(
    'form[action="/cart/add"] [type="submit"]'
  );

  buttons.forEach((btn) => {
    btn.addEventListener("click", function (e) {
      let form = e.currentTarget.closest("form");
      const data = Object.fromEntries(new FormData(form).entries());
      console.log(data);

      let _item = {
        AddedItemProductID: `${data["product-id"]}`,
        $use_ip: true,
        $is_session_activity: true,
      };

      setTimeout(
        function () {
          productAdded(_item);
        }.bind(this),
        3000
      );
    });
  });
})();

function productAdded(_item) {
  fetch(`${window.location.origin}/cart.js`).then((res) =>
    res
      .clone()
      .json()
      .then((data) => {
        var cart = {
          total_price: data.total_price / 100,
          $value: data.total_price / 100,
          total_discount: data.total_discount,
          original_total_price: data.original_total_price / 100,
          items: data.items,
        };

        let item_added = data.items.filter(
          (item) => item.product_id == parseInt(_item.AddedItemProductID)
        );

        console.log(item_added);

        _item["AddedItemProductName"] = item_added[0].product_title;
        _item["AddedItemSKU"] = item_added[0].sku;
        _item["AddedItemPrice"] = item_added[0].original_price;
        _item["AddedItemURL"] = item_added[0].url;
        _item["AddedItemImageURL"] = item_added[0].image;

        if (_item !== "undefined") {
          cart = Object.assign(cart, _item);
        }
        _learnq.push(["track", "Added to Cart", cart]);
        console.log("EVENT");
        console.log(cart);
      })
  );
}

// Sticky Add to Cart functionality
function handleStickyATC() {
  const scroll = window.scrollY;
  const stickyTriggerElement = document.querySelector("#productMainSubmit");
  const stickyATC = document.querySelector(".product-template__bottom-bar");
  const chatbox = document.querySelector(".intercom-launcher");

  if (stickyTriggerElement && stickyATC) {
    const stickyTrigger =
      stickyTriggerElement.getBoundingClientRect().top + window.scrollY;
    const stickyTriggerHeight = stickyTriggerElement.offsetHeight;
    const windowHeight = window.innerHeight;

    // Check if stickyTriggerElement is in the viewport
    if (
      scroll + windowHeight > stickyTrigger &&
      scroll < stickyTrigger + stickyTriggerHeight
    ) {
      // Element is visible, hide stickyATC
      stickyATC.classList.remove("active");
      if (chatbox) chatbox.style.bottom = ""; // Reset to default
      if (chatbox) chatbox.style.top = "block"; // Reset to default
    } else {
      // Element is not visible, show stickyATC
      stickyATC.classList.add("active");
    }
  }
}

// Update sticky ATC content when variant changes
async function updateStickyAtc(id, url, priceElement, section) {
  const res = await fetch(`${url}?variant=${id}&section_id=${section}`);
  const text = await res.text();

  const html = new DOMParser().parseFromString(text, "text/html");

  const source = html.querySelector(".price-item-sticky_atc");
  const sourcePriceATC = html.querySelector(".prices-items-collection");

  const sourcePrice = html.getElementById(`price-${section}`);
  const sourceVariants = html.querySelector(".variant-group-custom");

  const destinationPrice = document.getElementById(`price-${section}`);
  const destinationVariants = document.querySelector(".variant-group-custom");
  const destinationPriceATC = document.querySelector(
    ".prices-items-collection"
  );

  if (source && priceElement) priceElement.innerHTML = source.innerHTML;
  if (sourcePrice && destinationPrice)
    destinationPrice.innerHTML = sourcePrice.innerHTML;
  if (sourceVariants && destinationVariants)
    destinationVariants.innerHTML = sourceVariants.innerHTML;
  if (sourcePriceATC && destinationPriceATC)
    destinationPriceATC.innerHTML = sourcePriceATC.innerHTML;
}

// Update collection ATC content when variant changes
async function updateCollectionAtc(id, url, card) {
  const res = await fetch(`${url}?variant=${id}`);
  const text = await res.text();

  const html = new DOMParser().parseFromString(text, "text/html");

  const source = html.querySelector(".product-card__button-prices");
  const destinationPrice = card.querySelector(".prices-items-collection");

  const sourceSalePrice = html.querySelector(".price__sale .price-item--sale");
  const sourceSaleCompareAtPrice = html.querySelector(
    ".price-item__crossed .price-item--regular"
  );

  const destinationSalePrice = card.querySelector(
    ".product-card__button-price--new"
  );
  const destinationSaleCompareAtPrice = card.querySelector(
    ".price-item-collection_atc"
  );

  const sourceVariantName = html.querySelector(
    ".variant-group-new .variant-group-custom__label--active .variant-group-custom__value"
  );
  const destinationVariantName = card.querySelector(".variant-item_name");

  if (source.classList.contains("price--discounted")) {
    destinationPrice.innerHTML = source.innerHTML;
  } else {
    destinationSalePrice.innerHTML = sourceSalePrice.innerHTML;
    destinationSaleCompareAtPrice.innerHTML =
      sourceSaleCompareAtPrice.innerHTML;
  }

  if (sourceVariantName && destinationVariantName)
    destinationVariantName.innerHTML = sourceVariantName.innerHTML;
}

// Initialize sticky ATC functionality
window.addEventListener("scroll", handleStickyATC);
window.addEventListener("DOMContentLoaded", handleStickyATC);

